import React, { PureComponent } from 'react';
import { bool, func, objectOf } from 'prop-types';
import _get from 'lodash/get';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { appUndoAction } from 'yoda-site-components/lib/actions/NativeAppAction';
import Button from 'yoda-core-components/lib/components/Button';
import Utils from 'yoda-core-components/lib/helpers/Utils/Utils';
import { getPageURL, isBrandPage } from '../../utils';

export class NoGalleryResults extends PureComponent {
    static propTypes = {
        actions: objectOf(func).isRequired,
        isNative: bool,
        isPreview: bool,
    };

    static defaultProps = {
        isNative: false,
        isPreview: false,
    };

    componentDidMount() {
        /* istanbul ignore next */
        if (!__SERVER__ && !isBrandPage()) {
            window.addEventListener('load', window && window.scrollTo(0, 1));
        }
    }

    goBack = () => {
        const { actions, isNative } = this.props;

        if (isNative) return actions.appUndoAction();

        /* istanbul ignore next */
        if (window && window.history && window.history.length > 1) {
            return window.history.back();
        }
        /* istanbul ignore next */
        return null;
    };

    render() {
        const { isPreview } = this.props;
        const updatedItemStatusUrl = Utils.updateQueryStringParameter(
            getPageURL(),
            'item_status',
            '0'
        );

        return isBrandPage() ? null : (
            <div className="mt-3 text-center">
                <div className="font-open-sans-bold mt-2 text-gray-600 text-xlarge">Uh oh!</div>
                <div className="mt-3 text-gray-400 text-large">Your filters produced 0 results</div>
                <div className="my-3 mx-auto w-15">
                    <Button automationId="no results button" onClick={this.goBack}>
                        Undo
                    </Button>
                </div>
                {isPreview && (
                    <a
                        className="block w-72 h-6 text-base text-center text-gray-500 underline cursor-pointer"
                        href={updatedItemStatusUrl}
                    >
                        Show Out of Stock Items
                    </a>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    isNative: _get(state, 'context.isNative', false),
    isPreview: state.context ? state.context.isPreview : false,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            appUndoAction,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(NoGalleryResults);
